import { GROUP_BY_SN } from '../AC';

export default (state = false, { type, payload }) => {
	if (type === GROUP_BY_SN) {
		return payload;
	}
	return state;
};
